import { useApolloClient } from '@apollo/client';
import { useCallback, useEffect } from 'react';
import { NOTIFICATION_VARIANT, useNotifications } from '../../notifications/Notifications';
import type { SwarmFormController } from './form-controller';
import { NyDepDeviceRegistrationService } from './NyDepDeviceRegistrationService';

interface Props {
    formController: SwarmFormController;
}

/** Listens for successful measuring-point saves and triggers NY DEP registration. */
export function NyDepDeviceRegistrationListener({ formController }: Props) {
    const client = useApolloClient();
    const { addNotification } = useNotifications();
    const reportError = useCallback(
        (message: string) => {
            addNotification({
                message,
                variant: NOTIFICATION_VARIANT.WARNING,
                scrollToTop: true,
            });
        },
        [addNotification]
    );

    useEffect(() => {
        const service = new NyDepDeviceRegistrationService({
            client,
            formController,
            reportError,
        });
        const subscription = service.connect();

        return () => subscription.unsubscribe();
    }, [client, formController, reportError]);

    return null;
}
